module.exports = __webpack_public_path__ + "static/fonts/fontello.068ca2b.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/mavon-editor/dist/font/fontello.ttf
// module id = yxwh
// module chunks = 1